<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/g16RWg/tc-custom/9781504064019.jpg?1705751044695" alt="This image is the cover for the book Almost Dark"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Almost Dark
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An “</b><b>intelligent, melancholy, and terrifying</b><b>” </b><b>ghost story set in a picture-perfect Vermont town (Paul G. Tremblay, author of <i>The Cabin at the End of the World</i>).</b></p><p>In 1993, teenage Claire and her twin brother, Sam, sneak out to Farmington’s old textile factory, where they’ve heard the high school kids go to party. When Sam falls into a basement window and injures himself, Claire runs for help, thinking she’s left Sam alone. But something horrible is inside the otherwise empty factory with him . . .</p><p>Fifteen years later, Claire is working as Farmington’s librarian, secretly wrestling with her guilt after her brother’s death. She leads a quiet, lonely life—until Sam begins visiting her.</p><p>Meanwhile, Justin, an ambitious business developer, has come to town to transform the abandoned factory into a new boutique retail location. But a painful, violent past lies behind the building’s walls that, for everyone’s sake, might be better left undisturbed . . .</p><p>“A lyrical, haunting, and unsettling story . . . [crafted] out of the skeletons and whispers of a small town with a decidedly tragic past.” —Richard Thomas, author of <i>Disintegration</i></p> “Recalls the golden era of 1970s and 1980s horror fiction, but burnished with an entirely contemporary voice, crafted with a poet’s eye for detail and ear for language. Reminiscent of the early work of Rosemary Campbell and Charles L. Grant, simultaneously chilling and poignant, this novel and its inhabitants hauntedme long after I had uneasily put it down.” —Michael Rowe, author of <i>Enter, Night</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Letitia Trent
      </h2>
      
      <p class="authorDescription body article">Letitia Trent is a novelist, short story writer, and poet. Her Shirley Jackson Award&ndash;nominated short story, &ldquo;Wilderness,&rdquo; appeared in <I>The Best Horror of the Year Volume Eight</I>. Trent is the author of novels <I>Echo Lake</I> and <I>Almost Dark</I>, and poetry collections <I>Match Cut, The Ghost Comes with Me</I>, and <I>The Women in Charge</I>. Her short stories, poetry, and nonfiction have appeared in the<I> Daily Beast</I>,<I> Sou&rsquo;Wester</I>,<I> Diagram</I>,<I> Waxwing</I>,<I> Smokelong Quarterly</I>, and <I>Hobart</I>, among other publications. In addition to writing, she works in the mental health field. Trent lives in an Ozark mountain town with her husband, son, two black cats, and a dog named Sally.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8d06da20